(() => {
  const normalize = value => String(value ?? '').trim().toUpperCase();
  const sortSizes = (a,b) => {
    const order=['XXS','XS','S','M','L','XL','XXL','XXXL'];
    const an=/^\d+(?:[.,]\d+)?$/.test(a), bn=/^\d+(?:[.,]\d+)?$/.test(b);
    if(an && bn) return parseFloat(a.replace(',','.'))-parseFloat(b.replace(',','.'));
    if(an!==bn) return an?-1:1;
    const ai=order.indexOf(a),bi=order.indexOf(b);
    if(ai>=0 || bi>=0) return (ai<0?999:ai)-(bi<0?999:bi);
    return a.localeCompare(b,undefined,{numeric:true});
  };
  async function init(root) {
    if(root.dataset.initialized) return;
    root.dataset.initialized='true';
    const grid=root.querySelector('[data-rw-grid]'), controls=root.querySelector('[data-rw-controls]'), status=root.querySelector('[data-rw-status]'), retry=root.querySelector('[data-rw-retry]');
    if(!grid || !root.dataset.feedUrl) return;
    const categoryControl=root.querySelector('[data-rw-category]');
    const categoryOptions=root.querySelector('[data-rw-category-options]');
    const filter=root.querySelector('[data-rw-filter]');
    if(categoryOptions && categoryControl){
      categoryOptions.replaceChildren();
      Array.from(categoryControl.options).forEach(option=>{
        const button=document.createElement('button');
        button.type='button';button.dataset.rwCategoryValue=option.value;
        button.textContent=option.textContent;button.disabled=true;
        button.setAttribute('aria-pressed',String(!option.value));categoryOptions.append(button);
      });
      categoryOptions.addEventListener('click',event=>{
        const button=event.target.closest('button[data-rw-category-value]');
        if(!button || button.disabled || !ready)return;
        categoryControl.value=button.dataset.rwCategoryValue;
        category=categoryControl.value;load(true);filter.open=false;
        filter.querySelector('summary').focus();
      });
      categoryOptions.addEventListener('keydown',event=>{
        const buttons=Array.from(categoryOptions.querySelectorAll('button:not(:disabled)'));
        const index=buttons.indexOf(document.activeElement);let next=index;
        if(event.key==='ArrowDown')next=(index+1)%buttons.length;
        else if(event.key==='ArrowUp')next=(index+buttons.length-1)%buttons.length;
        else if(event.key==='Home')next=0;
        else if(event.key==='End')next=buttons.length-1;
        else return;
        if(buttons.length){event.preventDefault();buttons[next].focus();}
      });
      filter.addEventListener('keydown',event=>{if(event.key==='Escape'){filter.open=false;filter.querySelector('summary').focus();}});
    }
    let cards=[], ready=false, selected=normalize(new URL(location.href).searchParams.get('rw_size')||''), category='', requestId=0;
    const initialCategory=new URL(location.href).searchParams.get('rw_collection')||'';
    if(categoryControl){categoryControl.value=initialCategory;category=categoryControl.value;}
    const knownSizes=new Set();
    const originalAll=controls.querySelector('button');
    const indexCards=()=> {
      cards=Array.from(grid.children).map(card=>{
        const variants=JSON.parse(card.querySelector('template').content.textContent);
        const available=variants.filter(v=>v.available);
        const sizes=[...new Set(available.filter(v=>v.size!==null).map(v=>normalize(v.size)))].sort(sortSizes);
        card.querySelector('[data-rw-sizes]').textContent=sizes.join(' · ');
        const links=Array.from(card.querySelectorAll('[data-rw-link]'));
        return {card,available,sizes,collections:(card.dataset.rwCollections||'').split(' '),links,url:links[0].getAttribute('href')};
      });
    };
    function apply(value,writeUrl=true){
      selected=normalize(value);
      let count=0;
      cards.forEach(item=>{
        const match=selected?item.available.find(v=>normalize(v.size)===selected):item.available[0];
        item.card.hidden=!match;
        if(match) count++;
        item.links.forEach(link=>{
          const url=new URL(item.url,location.origin);
          if(selected && match) url.searchParams.set('variant',String(match.id));
          link.setAttribute('href',url.pathname+url.search+url.hash);
          item.card.querySelectorAll('[data-product-url]').forEach(button=>button.setAttribute('data-product-url',url.pathname+url.search+url.hash));
        });
      });
      categoryOptions?.querySelectorAll('button').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.rwCategoryValue===category)));
      controls.querySelectorAll('button').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.rwSize===selected)));
      status.textContent=count?`${count} ${root.dataset.count}${selected?' · '+selected:''}`:root.dataset.empty;
      if(writeUrl){const url=new URL(location.href); selected?url.searchParams.set('rw_size',selected):url.searchParams.delete('rw_size');category?url.searchParams.set('rw_collection',category):url.searchParams.delete('rw_collection');history.replaceState(null,'',url);}
    }
    controls.addEventListener('click',event=>{const button=event.target.closest('button[data-rw-size]');if(ready && button && !button.disabled)apply(button.dataset.rwSize);});
    categoryControl?.addEventListener('change',()=>{if(!ready)return;category=categoryControl.value;load(true);root.querySelector('[data-rw-filter]').open=false;});
    window.addEventListener('popstate',()=>{
      const params=new URL(location.href).searchParams;
      selected=normalize(params.get('rw_size')||'');
      if(categoryControl){categoryControl.value=params.get('rw_collection')||'';category=categoryControl.value;}
      load(false);
    });
    async function load(writeUrl=false){
      const currentRequest=++requestId;
      ready=false;categoryOptions?.querySelectorAll('button').forEach(button=>button.disabled=true);
      if(categoryControl)categoryControl.disabled=true;
      retry.hidden=true;root.setAttribute('aria-busy','true');
      status.textContent=root.dataset.loading||'Loading…';
      grid.hidden=true;
      controls.querySelectorAll('button').forEach(button=>button.disabled=true);
      try {
        // Reload page one too: makes a retry atomic and independent of homepage ?page=.
        const option=categoryControl?Array.from(categoryControl.options).find(option=>option.value===category):null;
        const feedUrl=category && option?.dataset.feedUrl?option.dataset.feedUrl:root.dataset.feedUrl;
        const firstUrl=new URL(feedUrl,location.origin);
        firstUrl.searchParams.set('view','rewear-size-feed');firstUrl.searchParams.set('page','1');
        const fetchPage=async url=>{
          const response=await fetch(url,{credentials:'same-origin',headers:{Accept:'text/html'}});
          if(!response.ok)throw new Error('Catalogue response '+response.status);
          const doc=new DOMParser().parseFromString(await response.text(),'text/html');
          const feed=doc.querySelector('[data-rw-feed]');
          if(!feed)throw new Error('Missing catalogue template');
          return feed;
        };
        const first=await fetchPage(firstUrl);
        const pages=Number(first.dataset.pages);
        if(!Number.isInteger(pages)||pages<0)throw new Error('Invalid pagination');
        const fragment=document.createDocumentFragment();const seen=new Set();
        const append=feed=>feed.querySelectorAll('[data-rw-product]').forEach(card=>{if(!seen.has(card.dataset.rwProduct)){seen.add(card.dataset.rwProduct);fragment.append(card);}});
        append(first);
        for(let page=2;page<=pages;page++){const url=new URL(firstUrl);url.searchParams.set('page',String(page));append(await fetchPage(url));}
        if(currentRequest!==requestId)return;
        grid.replaceChildren(fragment);indexCards();
        controls.replaceChildren(originalAll);originalAll.disabled=false;
        cards.flatMap(item=>item.sizes).forEach(size=>knownSizes.add(size));
        if(selected)knownSizes.add(selected);
        const sizes=[...knownSizes].sort(sortSizes);
        sizes.forEach(size=>{const button=document.createElement('button');button.type='button';button.dataset.rwSize=size;button.textContent=size;button.setAttribute('aria-pressed','false');controls.append(button);});
        categoryOptions?.querySelectorAll('button').forEach(button=>button.disabled=false);
        ready=true;if(categoryControl)categoryControl.disabled=false;
        grid.hidden=false;apply(selected,writeUrl);
      }catch(error){
        if(currentRequest!==requestId)return;
        status.textContent=root.dataset.error;retry.hidden=false;
        console.warn('REWEAR size catalogue:',error.message);
      }finally{if(currentRequest===requestId)root.removeAttribute('aria-busy');}
    }
    retry.addEventListener('click',()=>load(true));load(false);
  }
  const boot=scope=>scope.querySelectorAll('[data-rw-catalog]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot(document));else boot(document);
  document.addEventListener('shopify:section:load',event=>boot(event.target));
})();
